@if (showAnnounceKit()) {
  <announcekit #announcekitComponent
               widget="https://announcekit.app/widgets/v2/CEte8"/>
}
@if (!showAnnounceKit()) {
  <span></span>
}
